<template>
    <div id="dashboard">
        <div class="content-wrapper">
            <div class="page-heading">
                <div class="page-content fade-in-up">
                    <div class="row">
                        <div class="col-md-12">
                            <!-- <craftsmen-dashboard v-if="$store.getters.getAuth['userType'] === 'craftsmen'"></craftsmen-dashboard> -->
                            <super-user-dashboard :key="$store.getters.getLocale" :project-id="id"></super-user-dashboard>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//   import CraftsmenDashboard from './craftsmen/CraftsmenDashboard'
  import SuperUserDashboard from './superuser/SuperUserDashboard'

  export default {
    name: 'DashBoard',
    components: {
    //   CraftsmenDashboard,
      SuperUserDashboard
    },
    props: ['id'],
    
  }
</script>

<style scoped>

</style>